/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/109-bubbles': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M17 14.081c0 .711.407 1.327 1 1.628v.249a3.71 3.71 0 01-3.207-1.125 5.03 5.03 0 01-1.293.168c-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4 4.5 1.791 4.5 4c0 .865-.309 1.665-.834 2.32a1.81 1.81 0 00-.166.761zM8 0c4.351 0 7.89 2.822 7.997 6.336a6.123 6.123 0 00-2.497-.524c-1.493 0-2.903.523-3.971 1.472C8.422 8.268 7.812 9.588 7.812 11c0 .698.149 1.373.433 1.997a10.089 10.089 0 01-1.493-.076c-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.156 10.36-.001 8.54-.001 6.5c0-3.59 3.582-6.5 8-6.5z"/>'
  }
})
